import styled from 'styled-components';

export const StyledWrapperChip = styled.div<{
	color: string;
	justify: string;
	square: boolean;
	shadow: boolean;
	$fullWidth?: boolean;
}>`
	background-color: ${({ color }) => color};
	border-radius: ${({ square }) => (square ? '7px' : '100px')};
	box-shadow: 0px 4px 10px 0px
		${({ shadow, color }) => (shadow ? color : 'none')};
	display: flex;
	justify-content: ${({ justify }) => justify};
	align-items: center;
	padding: ${({ $fullWidth }) => ($fullWidth ? '6px 12px' : '3px')};
	max-width: ${({ $fullWidth }) => ($fullWidth ? 'none' : '14rem')};
	min-width: ${({ $fullWidth }) => ($fullWidth ? '0' : '8rem')};
	width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
	box-sizing: border-box;

	p {
		margin-left: ${({ $fullWidth }) => ($fullWidth ? '0' : '0.5rem')};
	}
`;

export const StyledStatusColor = styled.div<{ color: string }>`
	background-color: ${({ color }) => color};
	box-shadow: 0px 3px 10px 0px ${({ color }) => color};
	width: 0.8rem;
	height: 0.8rem;
	border-radius: 100px;
`;

export const StyledStatusWrapper = styled.div`
	width: 1rem;
	height: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 0.5rem;
`;
